// 3rd's
import {$fetch} from "ofetch";

// locals
import PostsModule from '~/repository/modules/post';
import ProfileModule from "~/repository/modules/profile";
import AuthModule from "~/repository/modules/auth";
import CommentsModule from "~/repository/modules/comments";
import UsersModule from "~/repository/modules/users";
import NotificationsModule from "~/repository/modules/notifications";
import TaxModule from "~/repository/modules/tax";

interface IApiInstance {
    posts: PostsModule;
    profile: ProfileModule;
    auth: AuthModule;
    comments: CommentsModule;
    users: UsersModule;
    notifications: NotificationsModule;
    tax: TaxModule;
}

export default defineNuxtPlugin(({$config}) => {
    const token = useCookie('auth_token')
    const locale = useCookie('redlike_locale')
    const {setMaintenance} = useMaintenance()
    const notificationsStore = useNotificationsStore();
    const fetcher = $fetch.create({
        credentials: "include",
        async onResponse({response}) {
            if (response._data.hasOwnProperty('updates')) {
                notificationsStore.setNotificationsCount(response._data.updates.notifications)
            }
        },
        async onRequest({request, options}) {
            const {API_URL, APP_URL} = $config.public;

            if (token) {
                options.headers = {
                    Authorization: 'Bearer ' + token.value
                }
            }

            options.headers = {
                Accept: "application/json",
                'Accept-Language': locale.value,
                Referer: APP_URL,
                ...options?.headers,
            };
            options.baseURL = API_URL;
        },
        async onResponseError({response}) {
            const status = response.status;
            if ([500].includes(status)) {
                console.error("[Laravel Error]", response.statusText, response._data);
            }

            if (response.status === 503) {
                setMaintenance(true)
            }
        },
    });


    const modules: IApiInstance = {
        posts: new PostsModule(fetcher),
        profile: new ProfileModule(fetcher),
        auth: new AuthModule(fetcher),
        comments: new CommentsModule(fetcher),
        users: new UsersModule(fetcher),
        notifications: new NotificationsModule(fetcher),
        tax: new TaxModule(fetcher)
    };

    return {
        provide: {
            api: modules,
            apiFetch: fetcher
        }
    };
});